import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { DocumentCategory } from '../../../models/DocumentCategory';

const CREATE_SENTINEL = '__create_new_category__';

type Props = {
  categories: DocumentCategory[];
  value: string | undefined;
  onChange: (categoryId: string) => void;
  onRequestCreate?: () => void;
  label?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  minWidth?: number;
};

export default function DocumentCategorySelect({
  categories,
  value,
  onChange,
  onRequestCreate,
  label = 'Category',
  size = 'small',
  fullWidth = false,
  minWidth = 180,
}: Props) {
  const labelId = React.useId();

  return (
    <FormControl size={size} fullWidth={fullWidth} sx={{ minWidth }}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={value ?? ''}
        onChange={(e) => {
          const next = e.target.value;
          if (next === CREATE_SENTINEL) {
            onRequestCreate?.();
            return;
          }
          onChange(next);
        }}
      >
        {categories.map((c) => (
          <MenuItem key={c.id} value={c.id}>
            {c.name}
            {c.isDefault ? ' (default)' : ''}
          </MenuItem>
        ))}
        {onRequestCreate && <MenuItem value={CREATE_SENTINEL}>＋ New category…</MenuItem>}
      </Select>
    </FormControl>
  );
}
